export const attachCDAccountRadioButtonList = [
    { name: 'Link an existing CD account', value: true },
    { name: 'Create a new CD account', value: false }
];
export const createCDAccountRadioButtonList = [
    { name: 'Create a new CD account', value: false }
];
